export default __webpack_public_path__ + "static/media/LIBRARY2.1290a01e.JPG";